module.exports = __webpack_public_path__ + "static/media/visiumLoad.c7dc84f6.png";